import { DateTime } from 'luxon';

const allowedContentType = [
  'application/pdf',
  'image/png',
  'image/jpeg',
] as const;

type AllowedContentType = (typeof allowedContentType)[number];

function isAllowedContentType(prefix?: string): prefix is AllowedContentType {
  return allowedContentType.includes(prefix as AllowedContentType);
}

const contentTypeMapping = {
  JVBE: 'application/pdf',
  iVBO: 'image/png',
  '/9j/': 'image/jpeg',
};

export const srcFromBase64 = ({
  base64,
  prefix,
}: {
  base64: string;
  prefix?: string;
}) => {
  if (isAllowedContentType(prefix)) {
    return `data:${prefix};base64,${base64}`;
  }

  const fourLetterOfBase64 = base64.slice(
    0,
    4
  ) as keyof typeof contentTypeMapping;

  return `data:${contentTypeMapping[fourLetterOfBase64]};base64,${base64}`;
};

enum DateTimeFormatFromEnum {
  Base = 'yyyy-MM-dd',
}

enum DateTimeFormatToEnum {
  DateSlashed = 'MM/dd/yyyy',
}

export const dateFormat = ({
  date,
  from,
  to,
}: {
  date?: string;
  from: keyof typeof DateTimeFormatFromEnum;
  to: keyof typeof DateTimeFormatToEnum;
}) => {
  if (!date) {
    return '';
  }

  return DateTime.fromFormat(date, DateTimeFormatFromEnum[from]).toFormat(
    DateTimeFormatToEnum[to]
  );
};

export const base64PDFToBlobUrl = (base64: string) => {
  const binStr = atob(base64);
  const uint8Array = new Uint8Array(binStr.length);
  const blobParts = uint8Array.map((_, index) => binStr.charCodeAt(index));
  const blob = new Blob([blobParts], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
};

export const formatTableTitle = (title: string, isMobile: boolean) => {
  return isMobile ? title : title.toUpperCase();
};
